import React from 'react'

const TextAreaField = ({
  name, label, rows, value, placeholder, errors, onChange,
  maxLength = null, className = 'form-group', labelClassName = '', textareaClassName = ''
}) => {
  const textareaClasses = ['form-control', textareaClassName, errors ? 'is-invalid' : '']
    .filter(Boolean).join(' ')

  return (
    <div className={className}>
      <label className={labelClassName} htmlFor={name}>{label}</label>
      <textarea
        className={textareaClasses}
        name={name}
        placeholder={placeholder}
        id={name}
        rows={rows}
        value={value}
        maxLength={maxLength}
        onChange={onChange}
      />
      {errors ? <small className="text-danger">{errors[0]}</small> : null}
    </div>
  )
}

export default TextAreaField
